<template>
  <div :class="groupClass">
    <SelectComponent
      v-model="localValue"
      :values="options"
      :searchable="searchable"
      :label="label"
      :placeholder="placeholder ?? label"
      :track-by="trackBy"
      :display-key="attributeLabel"
      :disabled="disabled"
      :required="required"
      :name="name"
      :label-class="labelClass"
      :select-class="selectClass"
    />
    <ErrorContainer v-if="cErrors.length" :error-key="name" :errors="cErrors" />
  </div>
</template>

<script>
import ErrorContainer from '@c/addf-package/components/BaseShowEditInput/ErrorContainer.vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'

import { fieldErrors } from './fieldErrors'

/**
 * Simple select keeping both contracts Crema's pages use:
 * - the former package's: starts from `defaultValue` (the selected option
 *   object, or its id) and emits `setSelected` with `{ value, attribute }`;
 * - `v-model` on the selected id.
 */
export default {
  name: 'BaseSelectSimple',
  components: { SelectComponent, ErrorContainer },
  props: {
    name: { type: String, required: true },
    label: { type: String, required: false, default: null },
    placeholder: { type: String, required: false, default: null },
    groupClass: { type: String, required: false, default: '' },
    labelClass: { type: String, required: false, default: '' },
    selectClass: { type: String, required: false, default: '' },
    errors: { type: [Object, Array], required: false, default: null },
    options: { type: Array, required: true },
    modelValue: {
      type: [Number, String, Object],
      required: false,
      default: undefined
    },
    defaultValue: {
      type: [Object, Array, Number, String],
      required: false,
      default: null
    },
    trackBy: { type: String, required: false, default: 'id' },
    attributeLabel: { type: String, required: false, default: 'name' },
    disabled: { type: Boolean, required: false, default: false },
    required: { type: Boolean, required: false, default: false },
    searchable: { type: Boolean, required: false, default: false }
  },
  emits: ['update:modelValue', 'setSelected'],
  data() {
    return { internalValue: this.idOf(this.defaultValue) }
  },
  computed: {
    cErrors() {
      return fieldErrors(this.errors, this.name)
    },
    localValue: {
      get() {
        return this.modelValue !== undefined
          ? this.idOf(this.modelValue)
          : this.internalValue
      },
      set(value) {
        this.internalValue = value
        this.$emit('update:modelValue', value)
        if (value !== null && value !== undefined) {
          this.$emit('setSelected', { value, attribute: this.name })
        }
      }
    }
  },
  methods: {
    idOf(value) {
      if (value === null || value === undefined) return null
      if (Array.isArray(value)) return value.length ? this.idOf(value[0]) : null
      return typeof value === 'object' ? (value[this.trackBy] ?? null) : value
    }
  }
}
</script>
